import React from 'react'
import PromotionsListTable from '../../components/Admin/PromotionsListTable';

const PromotionList = () => {
  return (
    <PromotionsListTable />
  )
}

export default PromotionList;